import { updatePhoneNumber } from '../helpers/update-phone-number';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface AddPhoneNumberFnPayload {
    phoneNumber: string;
}

export type AddPhoneNumberFn = (
    payload: AddPhoneNumberFnPayload,
) => Promise<void>;

export function initAddPhoneNumberFn({
    dependencies,
}: DomainInitPayload): AddPhoneNumberFn {
    return async (payload) => {
        try {
            await updatePhoneNumber(payload, dependencies);
        } catch (error: any) {
            // we silently catch error right now because this logic is a
            //  "try to add if we can"
            return;
        }
    };
}
